'use client';

import Link from 'next/link';

export default function CCPALink() {
  return (
    <Link
      href="/privacy#do-not-sell"
      className="text-sm font-body opacity-80 hover:opacity-100 transition-organic duration-300"
    >
      Do Not Sell My Personal Information
    </Link>
  );
}
